// THE DOOR'S MARK — what rides the white disc of every door into innernet
// (John, 2026-10-22: "the button on our signup page… the off-white and the
// white… rotating, but the cell inside never rotates. that's the sort of
// button i want").
//
// One door, everywhere: the off-white SOLID pill (`btn-pill--solid`), the white
// disc, and netti's own gradient mark in it, sized to fill the disc a little
// more than a glyph would (26 of 44). Only the petals turn on hover; the cell
// holds its stance (law_mark_stance, `.pill-netti .om-petals` in globals.css).
// Never a filled gradient capsule, never the mark in the room's tint.

import OrganismMark from "./OrganismMark";

/** the mark's size inside the 44px disc */
export const DOOR_MARK_SIZE = 26;

export default function DoorMark({ className }: { className?: string }) {
  return <OrganismMark tone="gradient" size={DOOR_MARK_SIZE} className={`pill-netti${className ? ` ${className}` : ""}`} />;
}
